import { Client } from "@/Common/Api/Client";
import { ClientResponse } from "@/Common/Api/ClientResponse";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { SaveFlowsheetFilterSettingsRequest } from "./Contracts/SaveFlowsheetFilterSettingsRequest";

class FlowsheetFilterSettingsClient {
    /**
     * Saves the flowsheet settings
     */
    public static async saveFlowsheetSettings(request: SaveFlowsheetFilterSettingsRequest): Promise<ClientResponse> {
        return await Client.postAsync(ServerOperations.Server.Myle_FlowsheetModule_SaveFilterSettings, request);
    }
}

export { FlowsheetFilterSettingsClient };
